export default "__VITE_ASSET__Cvjei7Uj__"